import { FunctionComponent } from "react";

interface IProps {
  stroke?: string;
  width?: string;
  height?: string;
}

const Cross: FunctionComponent<IProps> = ({ stroke = "#111", width = "16", height = "16" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
    <path
      d="M1.98043 1.97994C2.17569 1.78468 2.4922 1.78468 2.68746 1.97994L14.0208 13.3133C14.2161 13.5085 14.2161 13.825 14.0208 14.0203C13.8255 14.2156 13.509 14.2156 13.3138 14.0203L1.98043 2.68697C1.78517 2.49171 1.78517 2.1752 1.98043 1.97994Z"
      fill={stroke}
    />
    <path
      d="M13.3138 1.97994C13.509 1.78468 13.8255 1.78468 14.0208 1.97994C14.2161 2.1752 14.2161 2.49171 14.0208 2.68697L2.68746 14.0203C2.4922 14.2156 2.17569 14.2156 1.98043 14.0203C1.78517 13.825 1.78517 13.5085 1.98043 13.3133L13.3138 1.97994Z"
      fill={stroke}
    />
  </svg>
);

export default Cross;
